import React, { useState, useRef } from 'react';
import Swal from 'sweetalert2';
import './Crash.css';
import { useTokens } from '../components/TokenContext';

function Crash() {
    const [bet, setBet] = useState('');
    const [multiplier, setMultiplier] = useState(1.0);
    const [isRunning, setIsRunning] = useState(false);
    const [hasCashedOut, setHasCashedOut] = useState(false);
    const [gameId, setGameId] = useState(null);
    const intervalRef = useRef(null);
    const { fetchTokens } = useTokens();

    const startGame = async () => {
        const userId = localStorage.getItem('fw_user');
        if (!userId) {
            Swal.fire('Chyba', 'Uživatel není přihlášen.', 'error');
            return;
        }

        if (!bet || bet <= 0) {
            Swal.fire('Chyba', 'Zadejte platnou sázku.', 'warning');
            return;
        }

        try {
            const response = await fetch('https://api.fantasyworldtrpg.cz/casino-api/crash_start.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: new URLSearchParams({
                    user_id: userId,
                    bet
                })
            });

            const data = await response.json();

            if (data.error) {
                Swal.fire('Chyba', data.error, 'error');
                return;
            }

            setGameId(data.game_id);
            setMultiplier(1.0);
            setIsRunning(true);
            setHasCashedOut(false);

            intervalRef.current = setInterval(() => {
                setMultiplier(prev => {
                    const next = (prev + 0.01).toFixed(2);
                    return parseFloat(next);
                });
            }, 50);
        } catch (error) {
            Swal.fire('Chyba', 'Nepodařilo se spojit se serverem.', 'error');
        }
    };

    const stopGame = () => {
        clearInterval(intervalRef.current);
        setIsRunning(false);
    };

    const cashOut = async () => {
        if (!isRunning || hasCashedOut || !gameId) return;

        stopGame();
        setHasCashedOut(true);

        const userId = localStorage.getItem('fw_user');
        const payout = (bet * multiplier).toFixed(2);

        try {
            const response = await fetch('https://api.fantasyworldtrpg.cz/casino-api/crash_cashout.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: new URLSearchParams({
                    user_id: userId,
                    game_id: gameId,
                    multiplier
                })
            });

            const data = await response.json();

            if (data.error) {
                Swal.fire('Smůla 😢', data.error, 'error');
                return;
            }

            Swal.fire('Výhra! 🎉', `Získal jsi ${data.payout.toLocaleString('cs-CZ')} Coinů!`, 'success');
            fetchTokens();
        } catch (err) {
            Swal.fire('Chyba', 'Nepodařilo se spojit se serverem.', 'error');
        }
    };

    return (
        <div className="game-crash">
            <h1>Crash 🚀</h1>
            <p>Pravidla: Sleduj nárůst násobku a vyber dřív, než hra spadne!</p>

            <div className="input-container">
                <input
                    type="number"
                    min="1"
                    value={bet}
                    onChange={(e) => setBet(e.target.value)}
                    placeholder="Zadej sázku"
                    className="form-control"
                    disabled={isRunning}
                />
                <button className="btn btn-success" onClick={startGame} disabled={isRunning}>Start</button>
                <button className="btn btn-warning" onClick={cashOut} disabled={!isRunning || hasCashedOut}>Cash Out</button>
            </div>

            <div className={`multiplier ${isRunning ? 'running' : ''}`}>
                {multiplier.toFixed(2)}x
            </div>
        </div>
    );
}

export default Crash;
